export interface ICommentResponse {
  Id?: number
  Content?: string
  CreatedBy?: string
  IsPrivileged?: boolean
  DateCreated?: Date
}

export interface ICommentResponseV1 {
  id?: number
  content?: string
  createdBy?: string
  isPrivileged?: boolean
  dateCreated?: Date
}

export class Comment {
  public id?: number
  public content?: string
  public createdBy?: string
  /*
     * A flag to determine whether or not the current user owns the comment.
     */
  public isPrivileged?: boolean = false
  public dateCreated?: Date

  constructor(comment: Partial<Comment>) {
    this.id = comment.id
    this.content = comment.content
    this.createdBy = comment.createdBy ?? "Unknown Guest"
    this.isPrivileged = comment.isPrivileged ?? false
    this.dateCreated = comment.dateCreated
  }

  public static fromResponse(response: ICommentResponse) {
    const dateCreated = response?.DateCreated ? new Date(response?.DateCreated) : undefined

    return new Comment({
      id: response?.Id,
      content: response.Content,
      createdBy: response?.CreatedBy,
      isPrivileged: response?.IsPrivileged,
      dateCreated,
    })
  }

  public static fromResponseV1(response: ICommentResponseV1) {
    return new Comment({
      id: response.id,
      content: response.content,
      createdBy: response.createdBy,
      isPrivileged: response.isPrivileged ?? false,
      dateCreated: response.dateCreated,
    })
  }
}
